export const ima3 = () => {
    const existingScript = document.getElementById('ima3');
     if (!existingScript) {
        return new Promise((resolve, reject) => {
            var script = document.createElement('script');
            script.type = 'text/javascript';
            script.async = true;
            script.id = 'ima3';
            script.src = 'https://imasdk.googleapis.com/js/sdkloader/ima3.js';
            script.onload = () => {
                resolve();
            }
            script.onerror = () => {
                reject('Cannot load ima3 JS')
                document.body.removeChild(script);
            }
            document.body.appendChild(script);
        })
    }
}
export const platform = () => {
    const existingScript = document.getElementById('platform');
     if (!existingScript) {
        return new Promise((resolve, reject) => {
            var script = document.createElement('script');
            script.type = 'text/javascript';
            script.async = true;
            script.id = 'platform';
            script.src = window.settings.layoutUrlBase+'assets/platform.js';
            script.onload = () => {
                resolve();
            }
            script.onerror = () => {
                reject('Cannot load platform JS')
                document.body.removeChild(script);
            }
            document.body.appendChild(script);
        })
    }
}